import React from 'react';
import { View, StyleSheet, Text, Dimensions } from 'react-native';
import colors from '../config/colors';
var windowWidth = Dimensions.get('window').width;
var windowHeight = Dimensions.get('window').height;
function NotFoundMessage({ textMsg, styleMessage }) {
    return (
        <View style={styles.container}>
            <View style={styles.popup}>
                {/* <MaterialIcons
                    onPress={() => {
                        setMas(false)
                    }}
                    name={"cancel"}
                    size={25}
                    color={colors.white}
                    style={styles.iconCanImg}
                /> */}
                <Text style={styles.textMsj}>
                    {textMsg}
                </Text>
                {/* <Text style={styles.textName}>
                    {JSON.parse(user).userName}
                </Text>
                <Text style={{ color: colors.green }}>
                    Alias
                </Text>
                <Text style={styles.textName}>
                    {JSON.parse(user).alias}
                </Text>
                <Text style={{ color: colors.green }}>
                    Yo soy
                </Text> */}

            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: '100%'
    },
    popup: {
        marginLeft: (windowWidth * .1),
        marginTop: (windowWidth * .1),
        //position: 'absolute',
        //backgroundColor: colors.fondoImagenes,
        zIndex: 1,
        width: (windowWidth * .8),
        padding: (windowWidth * .05),
        borderRadius: 15,
        // borderWidth: 1,
        // borderColor: colors.fondoInput
        // height:(windowWidth * .8)
    },
    textMsj: {
        fontSize: 20,
        color: colors.green,
        textAlign: "center",
        width: "90%"
    }

})

export default NotFoundMessage;